import React from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  useRemoveProjectFromPortfolio,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectFromPortfolioRemoval({ portfolio, project, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeProjectFromPortfolio } =
    useRemoveProjectFromPortfolio(portfolio, project);
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <Modal
      header={t("removeProjectFromPortfolio.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <p className={styles.text}>
          <Trans>
            {t("removeProjectFromPortfolio.confirmation", {
              project: project.name,
              portfolio: portfolio.name,
            })}
          </Trans>
        </p>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeProjectFromPortfolio.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() =>
              removeProjectFromPortfolio({ portfolio, project, planzone })
            }
          >
            {t("removeProjectFromPortfolio.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ProjectFromPortfolioRemoval };
